
export type MarkNotificationAsRead200Status = {
  isRead: boolean;
};
